import React from 'react';
import { Check } from 'lucide-react';

const TrustMicrocopy = () => {
  const features = [
    'No hidden fees',
    'Licensed providers',
    '24/7 support available',
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 py-3">
      {features.map((feature, index) => (
        <div key={index} className="flex items-center gap-1.5">
          <Check className="h-4 w-4 text-primary" />
          <span className="text-sm text-foreground/70">{feature}</span>
        </div>
      ))}
    </div>
  );
};

export default TrustMicrocopy;
